"use client";

import { Capacitor } from "@capacitor/core";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const WidgetStatsPublisher = dynamic(
  () =>
    import("@/components/providers/widget-stats-publisher").then(
      (module) => module.WidgetStatsPublisher,
    ),
  { ssr: false },
);

const ShareTargetsPublisher = dynamic(
  () =>
    import("@/components/providers/share-targets-publisher").then(
      (module) => module.ShareTargetsPublisher,
    ),
  { ssr: false },
);

/**
 * Native-only, and code-split: the publisher and its server action load in
 * their own chunk after hydration, so web visitors never download them. It
 * used to mount only inside the mini-apps, which left every widget stale for
 * anyone who did not open Movement or Weight Training.
 */
export function NativeWidgetStatsPublisher() {
  const [isNative, setIsNative] = useState(false);
  useEffect(() => setIsNative(Capacitor.isNativePlatform()), []);
  // The share sheet's chat suggestions ride along: same native-only gate,
  // same after-hydration chunk.
  return isNative ? (
    <>
      <WidgetStatsPublisher />
      <ShareTargetsPublisher />
    </>
  ) : null;
}
